import React from 'react';
import { graphql } from 'gatsby';
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews';
import Post, { PostProps } from '@components/post';

const GuidesPostPage = ({ data }: PostProps): JSX.Element => <Post data={data} />;

export default withPrismicPreview(GuidesPostPage);

export const query = graphql`
  query GuidesPostQuery($uid: String, $categoriesArray: [String]) {
    prismicGeneralConfig {
      ...GeneralConfigFragment
    }
    prismicPostPageConfig {
      ...PostPageConfigFragment
    }
    currentPost: allPrismicGuidesPost(filter: { uid: { eq: $uid } }) {
      edges {
        node {
          ...GuidesPostFragment
        }
      }
    }
    relativePosts: allPrismicGuidesPost(
      filter: { tags: { in: $categoriesArray }, uid: { ne: $uid } }
      limit: 3
      sort: { fields: first_publication_date, order: DESC }
    ) {
      edges {
        node {
          ...GuidesPostPreviewFragment
        }
      }
    }
    restPosts: allPrismicGuidesPost(
      filter: { uid: { ne: $uid } }
      limit: 3
      sort: { fields: first_publication_date, order: DESC }
    ) {
      edges {
        node {
          ...GuidesPostPreviewFragment
        }
      }
    }
  }
`;
